import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timestampDate', standalone: true, pure: true
})
export class TimestampDatePipe implements PipeTransform {


  transform(
    value: any,
    locale: string = 'en-US',
    timeZone?: string,
    options: Intl.DateTimeFormatOptions = { dateStyle: 'short', timeStyle: 'short' }
  ): string {
    if (value == null) return '';
    const secs = value.seconds ?? value._seconds ?? value?.value?.seconds;
    const nanos = value.nanos ?? value._nanos ?? value?.value?.nanos ?? 0;

    let ms: number | null = null;

    if (secs != null) {
      const s = typeof secs === 'string' ? Number(secs) : secs;
      if (!Number.isFinite(s)) return '';
      ms = s * 1000 + Math.floor((Number(nanos) || 0) / 1e6);
    } else if (value instanceof Date) {
      ms = value.getTime();
    } else if (typeof value === 'number' || typeof value === 'string') {
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      ms = n < 1e12 ? n * 1000 : n;
    }

    if (ms == null) return '';
    const d = new Date(ms);
    if (isNaN(d.getTime())) return '';

    return new Intl.DateTimeFormat(locale, { ...options, timeZone }).format(d);
  }

}
